<!-- View Mode -->
<ng-container *ngIf="!srv.editing">
  <nz-space>
    <app-page-how-to-toolbar-btn></app-page-how-to-toolbar-btn>
    <button type="button" *ngIf="!srv.editing && srv.previousRecordUrl" nz-button nzType="default" nz-tooltip
      nzTooltipTitle="Previous Record" nzShape="circle" (click)="prev()">
      <i nz-icon nzType="left" nzTheme="outline"></i>
    </button>
    <button type="button" *ngIf="!srv.editing && srv.nextRecordUrl" nz-button nzType="default" nz-tooltip nzTooltipTitle="Next Record"
      nzShape="circle" (click)="next()">
      <i nz-icon nzType="right" nzTheme="outline"></i>
    </button>
    <button type="button" nz-button nz-dropdown [nzDropdownMenu]="viewMenu" class="request-info-btn"
      *ngIf="einvEnabled && (aclKey === 'customer' || aclKey === 'supplier')" [disabled]="
        srv.loading || (aclKey === 'customer' && !einvFullValidationEnabled)
      ">
      <span nz-icon nzType="send" nzTheme="outline"></span>
      <span class="hidden-mobile">Request Info</span>
    </button>
    <nz-dropdown-menu #viewMenu="nzDropdownMenu">
      <ul nz-menu>
        <!-- <li nz-menu-group nzTitle="Request Info"> </li> -->
        <li nz-menu-divider></li>
        <li nz-menu-item (click)="share('EMAIL')">
          <i nz-icon nzType="mail"></i> Send Email
        </li>
        <li nz-menu-item (click)="share('WHATSAPP')">
          <i nz-icon nzType="whats-app"></i> Send WhatsApp Message
        </li>
        <li nz-menu-item (click)="share('TELEGRAM')">
          <i nz-icon nzType="send"></i> Send Telegram Message
        </li>
        <li nz-menu-item (click)="share('LINK')">
          <i nz-icon nzType="link"></i> Copy Link
        </li>
      </ul>
    </nz-dropdown-menu>
    <button type="button" nz-button class="add-btn" *ngIf="canCreate" (click)="gotoNew()" [disabled]="srv.loading">
      Add
    </button>
    <button type="button" nz-button *ngIf="canEdit && allowEdit" nzType="primary" (click)="toggleMode('edit')"
      [disabled]="srv.loading || (!srv.loading && disableEdit)">
      Edit
    </button>

    <div class="ml-sm mr-sm">
      <ng-container *ngIf="reportType">
        <app-preview-doc [docCode]="srv.code" [reportTypes]="[{ reportType: reportType }]"></app-preview-doc>
      </ng-container>
    </div>

    <button type="button" nz-button nz-dropdown [nzDropdownMenu]="more" nzPlacement="bottomRight"
      [disabled]="srv.loading">
      <span nz-icon nzType="ellipsis"> </span>
    </button>
  </nz-space>
  <nz-dropdown-menu #more="nzDropdownMenu">
    <ul nz-menu>
      <li nz-menu-item class="reload-btn" (click)="reload()">Reload</li>
      @if (aclKey === 'sstreturn') {
      <li *ngIf="sstReturnStatus === false" nz-menu-item class="submit-btn"
        (click)="modalVisible.sstReturn.submit = true">Submit</li>
      <li *ngIf="sstReturnStatus === true" nz-menu-item class="unlock-btn"
        (click)="modalVisible.sstReturn.unlock = true">Unlock SST</li>
      }
      @if (aclKey === 'stk' || aclKey === 'customer' || aclKey === 'supplier') {
      <li *ngIf="allowEdit" nz-menu-item (click)="clone()" [acl]="srv.aclKey + '.create'">
        Clone
      </li>
      }
      <li nz-menu-item [acl]="aclKey + '.delete'" class="text-error" (click)="handleDelete()">
        Delete
      </li>
      <li nz-menu-divider></li>
      <li nz-menu-item class="close-btn" (click)="close()">Close</li>
    </ul>
  </nz-dropdown-menu>
</ng-container>

<!-- Edit Mode -->
<ng-container *ngIf="srv.editing">
  <nz-space>
    <app-page-how-to-toolbar-btn></app-page-how-to-toolbar-btn>
    <button type="button" nz-button class="cancel-btn" (click)="cancel()" [disabled]="srv.loading">
      Cancel
    </button>
    <button type="button" nz-button class="save-btn" (click)="save()" [disabled]="!saving && srv.loading"
      [nzLoading]="saving">
      <span nz-icon nzType="edit" nzTheme="outline" *ngIf="srv.modified"></span>
      Save
    </button>
    <button type="button" *ngIf="canCreate" nz-button nzType="primary" (click)="saveAndNew()"
      [disabled]="saving || srv.loading">
      Save & New
    </button>
    <button type="button" nz-button [disabled]="srv.loading" nz-dropdown [nzDropdownMenu]="saveMenu">
      <span nz-icon nzType="down"></span>
    </button>
  </nz-space>
  <nz-dropdown-menu #saveMenu="nzDropdownMenu">
    <ul nz-menu>
      <li nz-menu-item (click)="saveAndClose()">Save & Close</li>
    </ul>
  </nz-dropdown-menu>
</ng-container>

<nz-modal [(nzVisible)]="modalVisible.email" nzTitle="Recipient" (nzOnCancel)="modalVisible.email = false"
  (nzOnOk)="shareVia()" [nzOkLoading]="srv.loading">
  <ng-container *nzModalContent>
    <form nz-form #emailF="ngForm" labelWidth="0">
      <nz-form-item>
        <nz-form-control [nzErrorTip]="emailErrorTpl">
          <app-multi-email-input [(ngModel)]="emailList" required [maxLength]="500"></app-multi-email-input>
          <!-- <input nz-input name="email" pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$" type="email"
            placeholder="Email" [(ngModel)]="emailList" required /> -->
          <ng-template #emailErrorTpl let-i>
            @if (i.hasError('required')) {
            Email is required.
            }
            @if (i.hasError('pattern')) {
            Invalid email address.
            }
          </ng-template>
        </nz-form-control>
      </nz-form-item>
    </form>
  </ng-container>
</nz-modal>

<nz-modal [(nzVisible)]="modalVisible.whatsapp" nzTitle="Recipient" (nzOnCancel)="modalVisible.whatsapp = false"
  (nzOnOk)="shareVia()" [nzOkLoading]="srv.loading">
  <ng-container *nzModalContent>
    <form nz-form #whatsappF="ngForm" labelWidth="0">
      <nz-form-item>
        <nz-form-control nzErrorTip="Phone number is required!">
          <input type="tel" nz-input app-mobile-input [(ngModel)]="phoneNumber" name="phoneNumber"
            placeholder="Phone Number" required />
          <span class="text-secondary">{{ remark }}</span>
          <br />
          <span class="text-secondary">e.g. 60122003080</span>
        </nz-form-control>
      </nz-form-item>
    </form>
  </ng-container>
</nz-modal>

<app-sst-return-declaration-info-modal #sstReturn [(isVisible)]="modalVisible.sstReturn" [id]="id"
  [status]="sstReturnStatus"></app-sst-return-declaration-info-modal>